import React from 'react'
import Header from '../../components/header/Header'

const Service = () => {
  return (
    <div>
      <Header/>
    </div>
  )
}

export default Service